<template>
  <div class="inspector-panel" id="inspector-panel">
    <div class="panel-header">
      <div class="panel-title">Панель компонентов</div>
      <div class="panel-title-name">{{ currentObj.typeNameRu }}</div>
    </div>
    <div class="formgrid grid align-items-center vertical-container mt-1 ml-1" id="inspector-panel-grid">
      <div class="col-4">
        <label for="current.id" class="mb-1">Идент.:</label>
      </div>
      <div class="col-8">
        <InputText id="current.id" v-model="current.id" disabled style="width: 95%"></InputText>
      </div>
      <div class="col-4">
        <label for="current.tag" class="mb-1">Тег:</label>
      </div>
      <div class="col-8">
        <InputText id="current.tag" v-model="current.tag" :disabled="!editing" style="width: 95%"
          @input="onChangeString('tag')"></InputText>
      </div>
      <div class="col-4">
        <label for="current.x" class="mb-1">x:</label>
      </div>
      <div class="col-8">
        <InputText id="current.x" v-model="current.x" :disabled="!editing" style="width: 95%"
          @change="onChangeX($event.target)" type="number"
          onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
        </InputText>
      </div>
      <div class="col-4">
        <label for="current.y" class="mb-1">y:</label>
      </div>
      <div class="col-8">
        <InputText id="current.y" v-model="current.y" :disabled="!editing" style="width: 95%" type="number"
          onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
          @change="onChangeY($event.target)"></InputText>
      </div>
      <div class="col-4">
        <label for="current.width" class="mb-1">Ширина:</label>
      </div>
      <div class="col-8">
        <InputText id="current.width" v-model="current.width" :disabled="!editing" style="width: 95%" type="number"
          onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
          @input="onChangeWidth($event.target)"></InputText>
      </div>
      <div class="col-4">
        <label for="current.height" class="mb-1">Высота:</label>
      </div>
      <div class="col-8">
        <InputText id="current.height" v-model="current.height" :disabled="!editing" style="width: 95%" type="number"
          onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
          @input="onChangeHeight($event.target)"></InputText>
      </div>
      <div class="col-4">
        <label for="current.round" class="mb-1">Округление:</label>
      </div>
      <div class="col-8">
        <InputText id="current.round" v-model="current.round" :disabled="!editing || current.round === undefined"
          style="width: 95%" type="number" min="0"
          onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
          @input="onChangeString('round')"></InputText>
      </div>
      <div class="col-4">
        <label for="current.heading_caption" class="mb-1">Заголовок:</label>
      </div>
      <div class="col-8">
        <InputText id="current.heading_caption" v-model="current.heading_caption"
          :disabled="!editing || current.heading_caption === undefined" style="width: 95%"
          @input="onChangeString('heading_caption')"></InputText>
      </div>
      <div class="col-4">
        <label for="current.fill" class="mb-1">Цвет:</label>
      </div>
      <div class="col-8">
        <CustomColor v-model="current.fill" :disabled="!editing || current.fill === undefined"
          @update:modelValue="onChangeString('fill')" />
      </div>
      <div class="col-4">
        <label for="current.fontStyle" class="mb-1">Стиль(толщина):</label>
      </div>
      <div class="col-8">
        <Dropdown v-model="current.fontStyle" :disabled="!editing" :options="FONT_STYLES" optionLabel="fontStyle"
          optionValue="fontStyle" appendTo="body" style="width: 95%" showClear @change="onChangeString('fontStyle');">
        </Dropdown>
      </div>
      <div class="col-4">
        <label for="current.src" class="mb-1">SRC:</label>
      </div>
      <div class="col-8">
        <InputText id="current.src" v-model="current.src" :disabled="!editing || current.src === undefined"
          style="width: 95%" @input="onChangeString('src')"></InputText>
      </div>
      <div class="col-4">
        <label for="current.viewBox" class="mb-1">Растянуть:</label>
      </div>
      <div class="col-3">
        <Checkbox id="current.viewBox" v-model="current.viewBox" :disabled="!editing || current.viewBox === undefined"
          @change="onChangeString('viewBox')" binary />
      </div>
      <div class="col-3">
        <label for="current.viewBox" class="mb-1">binary:</label>
      </div>
      <div class="col-2">
        <Checkbox id="current.binary" v-model="current.binary" :disabled="!editing || current.binary === undefined"
          @change="onChangeString('binary')" binary />
      </div>
      <div class="col-4">
        <label for="current.type" class="mb-1">Режим:</label>
      </div>
      <div class="col-8">
        <InputText id="current.type" v-model="current.type" :disabled="!editing || current.type === undefined"
          style="width: 95%" @input="onChangeType('type')" type="number" min="0"></InputText>
      </div>
      <div class="col-2">
        <label for="current.PropertyURI" class="mb-1">URI:</label>
      </div>
      <div class="col-2">
        <Button :title="isURIText ? 'Выбрать из списка' : 'Ввести вручную'" class="p-button-sm"
          :icon="isURIText ? 'pi pi-bars' : 'pi pi-pencil'" @click="isURIText = !isURIText"
          :disabled="current.PropertyURI === undefined || !moveableItem">
        </Button>
      </div>
      <div class="col-8">
        <Dropdown v-if="!isURIText" v-model="current.PropertyURI" filter
          :disabled="current.PropertyURI === undefined || !moveableItem" :options="property" optionLabel="PropertyURI"
          optionValue="PropertyURI" appendTo="body" style="width: 95%" showClear
          @change="current.event = null; onChangeString('PropertyURI');">
        </Dropdown>
        <InputText v-else id="current.PropertyUR" v-model="current.PropertyURI"
          :disabled="current.PropertyURI === undefined || !moveableItem" style="width: 95%"
          @input="current.event = null; onChangeString('PropertyURI');"></InputText>
      </div>
      <div class="col-4">
        <label for="flangeNo" class="mb-1">Фланец:</label>
      </div>
      <div class="col-8">
        <InputText :value="flangeNo" disabled style="width: 95%"></InputText>
      </div>
      <div class="col-4">
        <label for="propertyName" class="mb-1">Свойство:</label>
      </div>
      <div class="col-8">
        <InputText :value="propertyName" disabled style="width: 95%"></InputText>
      </div>

      <div class="col-4">
        <label for="current.PropertyURI" class="mb-1">Событие:</label>
      </div>
      <div class="col-8">
        <Dropdown v-model="current.event" :disabled="current.PropertyURI === undefined || !moveableItem"
          :options="event" optionLabel="event_name" optionValue="event_name" appendTo="body" style="width: 95%" @change="
            current.PropertyURI = null;
          onChangeString('event');
          ">
        </Dropdown>
      </div>
      <div class="col-4">
        <label for="current.options" class="mb-1">Справочник:</label>
      </div>
      <div class="col-8">
        <Button title="..." class="p-button-sm" @click="isOptionsDialog = true" icon="pi pi-plus"
          :disabled="current.options === undefined || !moveableItem">
        </Button>
      </div>
      <div class="col-4 ">
        <label for="current.options" class="mb-1">JSON:</label>
      </div>
      <div class="col-8 mt-1">
        <Button title="..." class="p-button-sm" @click="isShowJson = !isShowJson" :disabled="!moveableItem"
          icon="pi pi-bars">
          <span>...</span>
        </Button>
      </div>
      <div v-if="isShowJson" class="col-12">{{ current }} </div>
    </div>
    <Dialog :header="'Справочник ' + current.id" v-model:visible="isOptionsDialog" :style="{ width: '588px' }" modal
      class="p-fluid" @show="showDialog()">
      <div style="height: 35vh">
        <div class="formgrid grid align-items-center vertical-container">
          <div class="col-3">
            <label>Значение:</label>
          </div>
          <div class="col-5">
            <label>Текст значения:</label>
          </div>
          <div class="col-3">
            <label>{{
              currentObj.typeName === "dropdown_"
                ? "Индекс изображения:"
                : "Цвет заливки:"
            }}</label>
          </div>
          <div class="col-1">
            <i class="pi pi-plus" style="cursor: pointer" @click="onClickInsertItem"></i>
          </div>
        </div>
        <div class="formgrid grid align-items-center vertical-container mt-1" v-for="(item, i) of optionsTemp" :key="i">
          <div class="col-3">
            <InputText autofocus v-model="item.id" :ref="i + 'id'" :class="{
              'p-invalid': item.id === '' || item.id === null || item.id === undefined,
            }"></InputText>
          </div>
          <div class="col-5">
            <InputText autofocus v-model="item.name" style="max-width: 100%" :class="{
              'p-invalid': (item.name || '') == '',
            }"></InputText>
          </div>
          <div class="col-3" v-if="currentObj.typeName === 'dropdown_'">
            <Dropdown v-model="item.image_index" :options="images" appendTo="body" showClear>
              <template #value="value">
                <img v-if="value?.value" :src="require(`/public/images/24x24/${value.value}.png`)" width="17"
                  class="mr-3" />
                <div>{{ value?.value }}</div>
              </template>
              <template #option="slotProps">
                <div class="container">
                  <img :src="require(`/public/images/24x24/${slotProps.option}.png`)" width="17" class="p-mr-3" />
                  <span class="block ml-1">{{ slotProps.option }}</span>
                </div>
              </template>
            </Dropdown>
          </div>
          <div class="col-3" v-if="currentObj.typeName === 'state_interpreter'">
            <CustomColor v-model="item.fill" />
          </div>
          <div class="col-1">
            <i class="pi pi-trash" style="cursor: pointer" @click="onClickDeleteItem(i)"></i>
          </div>
        </div>
      </div>
      <template #footer>
        <Button label="Отмена" icon="pi pi-times" class="p-button-text" @click="isOptionsDialog = false" />
        <Button label="Сохранить" icon="pi pi-check" @click="onSaveOptions" autofocus />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import EventBus from '@/core/EventBus';
import { usePropertyUtils } from './forms/composables/usePropertyUtils.js';
import { useComponentUtils } from './forms/composables/useComponentUtils.js';

const props = defineProps({
  value: {
    type: Object,
    default: () => ({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      id: '',
      PropertyURI: '',
    }),
  },
  moveableItem: {
    type: Object,
  },
  editing: {
    type: Boolean,
    default: false,
  },
  facilityId: {},
});

const emit = defineEmits(['update:value']);

const store = useStore();

const { preparePropertyEvent } = usePropertyUtils();
const { prepareURI } = useComponentUtils();

const property = ref([]);
const event = ref(null);
const optionsTemp = ref(null);
const isOptionsDialog = ref(false);
const isShowJson = ref(false);
const isURIText = ref(false);
const OFFSET_WIDTH = ref(175);
const OFFSET_HEIGHT = ref(72);
const propertyService = ref(null);
const images = [
  0, 1, 2, 3, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 19, 22, 30,
  31, 33, 40, 45, 46, 51, 52, 53, 54, 56, 99,
];
const FONT_STYLES = [
  { fontStyle: 'normal' },
  { fontStyle: 'bold' },
  { fontStyle: 'bolder' },
  { fontStyle: 'lighter' },
];

const current = computed({
  get: () => props.value,
  set: (val) => emit('update:value', val),
});

const propertyName = computed(() => {
  let result = '';
  if (current.value.PropertyURI) {
    const arr = current.value.PropertyURI.split(':фл=');
    result = arr[0];
  }
  return result;
});

const flangeNo = computed(() => {
  let result = '';
  if (current.value.PropertyURI) {
    const arr = current.value.PropertyURI.split(':фл=');
    if (arr.length > 1) result = arr[1];
  }
  return result;
});

const currentObj = computed(() => {
  const name = current.value.id.replace(/\d+$/, '');
  for (const component of store.getters.components) {
    if (component.typeName === name) return component;
  }
  return {};
});

const calcOffset = () => {
  let left = store.getters.showFacilitiesMenu ? 8.5 : 0;
  if (document.documentElement.clientWidth < 1332) {
    OFFSET_WIDTH.value = left ? 114 : 0;
    return;
  }
  if (document.documentElement.clientWidth > 2122) {
    const addition = left * (1 - 2122 / document.documentElement.clientWidth);
    left = left - addition;
  }
  OFFSET_WIDTH.value = Math.round(document.documentElement.clientWidth * (left / 100));
};

const createPropertyService = () => {
  if (!propertyService.value) {
    propertyService.value = store.getters.nameToService(
      'BaseService',
      store.getters.info.login,
      store.getters.info.password,
      'property',
      'facility'
    );
  }
};

const onChangeHeight = () => {
  props.moveableItem?.request('resizable', {
    offsetHeight: parseFloat(current.value.height),
    isInstant: true,
  });
};

const onChangeWidth = () => {
  props.moveableItem?.request('resizable', {
    offsetWidth: parseFloat(current.value.width),
    isInstant: true,
  });
};

const onChangeX = () => {
  props.moveableItem?.request('draggable', {
    x: parseFloat(current.value.x) + OFFSET_WIDTH.value,
    isInstant: true,
  });
};

const onChangeY = () => {
  props.moveableItem?.request('draggable', {
    y: parseFloat(current.value.y) + OFFSET_HEIGHT.value,
    isInstant: true,
  });
};

const onChangeType = () => {
  current.value.type = Number(current.value.type);
  EventBus.emit('on-update-component', current.value);
};

const onChangeString = () => {
  EventBus.emit('on-update-component', current.value);
};

const showDialog = () => {
  optionsTemp.value = JSON.parse(JSON.stringify(current.value.options));
};

const hideDialog = () => {
  isOptionsDialog.value = false;
};

const onClickDeleteItem = (i) => {
  optionsTemp.value.splice(i, 1);
};

const onClickInsertItem = () => {
  optionsTemp.value.push({ image_index: 1 });
};

const onSaveOptions = () => {
  for (const element of optionsTemp.value) {
    if (element.id === null || element.name === undefined) {
      return;
    }
    if (element.id === 'false') element.id = false;
    if (element.id === 'true') element.id = true;
  }
  current.value.options = optionsTemp.value;
  EventBus.emit('on-update-component', current.value);
  isOptionsDialog.value = false;
};

const dragElement = (elmnt) => {
  let pos2 = 0,
    pos4 = 0;

  elmnt.onmousedown = dragMouseDown;

  function dragMouseDown(e) {
    if (
      e.target.localName !== 'input' &&
      e.target.localName !== 'textarea' &&
      e.target.localName !== 'span' &&
      !e.target.classList.contains('p-colorpicker-color')
    ) {
      e = e || window.event;
      e.preventDefault();
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }
  }

  function elementDrag(e) {
    e = e || window.event;
    pos2 = pos4 - e.clientY;
    pos4 = e.clientY;
    elmnt.style.top = Number(elmnt.style.top.substr(0, elmnt.style.top.length - 2)) - pos2 + 'px';
  }

  function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  }
};

onMounted(() => {
  const panelEl = document.getElementById('inspector-panel');
  if (panelEl) {
    panelEl.style.position = 'absolute';
    panelEl.style.left = '84%';
    panelEl.style.top = '50px';
    dragElement(panelEl);
  }

  window.addEventListener('resize', calcOffset);
  calcOffset();

  createPropertyService();
  propertyService.value
    .getData({ facility_id: props.facilityId })
    .then((data) => {
      const propList = prepareURI(data, 'property_name', 'active_flange_no');
      const eventList = [{ PropertyURI: 'Последнее событие' }];
      const eventOptions = preparePropertyEvent('event_name');
      event.value = eventOptions;
      property.value = [...eventList, ...propList];
    })
    .catch((er) => store.commit('SET_ERROR', {
      er: er?.response ?? er,
      source: ["InspectorPanel", "onMounted"],
    }));
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', calcOffset);
});
</script>

<style scoped lang="scss">
::v-deep(.p-dropdown-label) {
  display: flex;
  align-items: center;
  background-color: white;
}

.container {
  display: flex;
}

.input-color {
  width: 44.65%;
  padding: 0 0 0 0;
}

.inspector-panel {
  font-size: 0.96rem;
  padding-bottom: 4px;
  max-width: 320px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  right: 20px;
  margin-top: 10px;
  width: 305px;
  max-height: 80vh;
  background: var(--surface-d);
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 3;
  color: var(--text-color);
  overflow: hidden;
  transition: all 0.3s ease;

  .p-inputtext {
    padding: 0rem 0.5rem;
  }

  ::v-deep(.p-dropdown) {
    padding: 0rem 0.5rem;

    .p-dropdown-label {
      padding: 0px;
    }
  }

  .panel-header {
    padding: 8px 16px;
    border-bottom: 1px solid var(--primary-color);

    .panel-title {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 500;
    }

    .panel-title-name {
      opacity: 0.85;
      margin-top: 0.2rem;
      font-size: 1rem;
      font-weight: 500;
    }
  }
}
</style>